module.exports = __webpack_public_path__ + "static/media/Slide53.78877139.JPG";